import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import {BrowserRouter } from 'react-router-dom';
import {Provider} from 'react-redux';
import {createStore,compose, applyMiddleware,combineReducers} from 'redux';
import thunk from 'redux-thunk';
import burgerBuilderReducer from './store/reducers/burgerBuilder';
import orderReducer from './store/reducers/order';
import authReducer from './store/reducers/auth';
import {StripeProvider} from 'react-stripe-elements';
const composeEnhancers =process.env.NODE_ENV ==='development' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : null || compose;

const rootReducers =combineReducers({
    burger:burgerBuilderReducer,
    orders:orderReducer,
    auth:authReducer
});

const store= createStore(rootReducers,composeEnhancers(
    applyMiddleware(thunk)
));

const app=(
    <StripeProvider apiKey="pk_test_YXxx1T8deII1T8khvrDi5Rbm00bcuvihrb">
    <Provider store={store}>
        <BrowserRouter>
            <App/>
        </BrowserRouter>
    </Provider>
    </StripeProvider>
);

ReactDOM.render(app, document.getElementById('root'));
registerServiceWorker();
